import React, { useId } from 'react';

interface MoonIconProps {
  className?: string;
  size?: number;
}

/**
 * Moon icon component
 * Displays a crescent moon with gradient for dark mode
 */
export const MoonIcon: React.FC<MoonIconProps> = ({ 
  className = "", 
  size 
}) => {
  const sizeProps = size ? { width: size, height: size } : {};
  const uid = useId();
  const id = (name: string) => `${uid}-${name}`;
  
  return (
    <svg
      {...sizeProps}
      className={className}
      viewBox="0 0 512 512"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <linearGradient id={id("moon")}>
          <stop offset="0.52043599" style={{ stopColor: '#d4fcff', stopOpacity: 1 }} />
          <stop offset="1" style={{ stopColor: '#83d0d8', stopOpacity: 1 }} />
        </linearGradient>
        <radialGradient
          xlinkHref={`#${id("moon")}`}
          id={id("moon-applied")}
          cx="107.71187"
          cy="160.23351"
          fx="107.71187"
          fy="160.23351"
          r="245.13965"
          gradientTransform="matrix(-1.1797095,1.0625647,-1.0106735,-1.1220974,662.72641,200.70829)"
          gradientUnits="userSpaceOnUse"
        />
      </defs>
      <g>
        <path
          d="M 256.65735,47.258391 A 208.74115,208.74115 0 0 0 47.91575,256 208.74115,208.74115 0 0 0 256.65735,464.74161 208.74115,208.74115 0 0 0 464.08425,274.38601 151.71204,151.71204 0 0 1 354.50104,321.674 151.71204,151.71204 0 0 1 202.78754,169.96214 151.71204,151.71204 0 0 1 265.60664,47.478889 208.74115,208.74115 0 0 0 256.65735,47.258391 Z"
          fill={`url(#${id("moon-applied")})`}
        />
      </g>
    </svg>
  );
};
